export default {"src":"/_next/static/media/camera_onhover.ec3a34c8.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};